import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import {
  AUTHORIZATIONS,
  SSN_REKYC_PATH,
  USER_REGISTRATION_URL,
  TRANSFER_MONEY_URL,
  INITIATED,
  ACKNOWLEDGED,
  APPROVED
} from '../../utils/constants';
import { isKYCSplitFlow } from '../../utils/library';
import get from 'lodash/get';
import { NF_ALLOWED_ROUTES } from '../../screens/nium-forex/root/screenConstants';
import {
  selectIsNiumForexUser,
  selectUserSession,
  selectUserStatusReducer
} from '@Redux/selectors';

export const AuthLink = ({ target_path, className, id, onClick, caption }) => {
  const user_session = useSelector(selectUserSession);
  const userStatusReducer = useSelector(selectUserStatusReducer);
  const isNiumForexUser = useSelector(selectIsNiumForexUser);

  const validate_link = (user_status, target_path, sub_status) => {
    const { country_code } = user_session;

    if (isNiumForexUser) {
      return NF_ALLOWED_ROUTES.includes(target_path) ? target_path : false;
    } else if (
      (user_status === INITIATED || user_status === ACKNOWLEDGED) &&
      sub_status === 'REKYC' &&
      SSN_REKYC_PATH.includes(target_path)
    ) {
      if (target_path === TRANSFER_MONEY_URL) return USER_REGISTRATION_URL;
      else return target_path;
    } else if (!user_status) return false;

    let status = user_status;
    const accountType = get(userStatusReducer, 'account_type', '');

    if (isKYCSplitFlow(country_code, user_status, true, accountType)) {
      status = APPROVED;
    }

    return AUTHORIZATIONS[status].find((path) => path === target_path);
  };

  const { status, sub_status } = userStatusReducer;
  const path = validate_link(status, target_path, sub_status);

  if (!path) return null;

  return (
    <NavLink
      className={({ isActive }) => `${className || ''} ${isActive ? 'active-link' : ''}`.trim()}
      to={target_path}
      id={id}
      onClick={onClick}
    >
      {caption}
    </NavLink>
  );
};

AuthLink.propTypes = {
  id: PropTypes.string,
  caption: PropTypes.string,
  target_path: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default AuthLink;
